import {http} from '@/http'

export default {
  getBusiness(slug) {
    return http.get('api/v1/business', {params: {slug}});
  },
}
